module.exports = __webpack_public_path__ + "img/nav-designer.ba8bda9.jpg";